export const LOGIN_FORM = "LOGIN_FORM";
export const SET_LOADING = "SET_LOADING";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE"
export const SET_CURRENT_PROFILE = 'SET_CURRENT_PROFILE'
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS"
export const LOGIN_ERROR = "LOGIN_ERROR"
export const SET_IS_LOADING = "SET_IS_LOADING"
export const LOGOUT_USER = "LOGOUT_USER";